import ListRetailPrescriptions from "../../../../components/@documents/retail_prescriptions/ListRetailPrescriptions";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function RetailPrescriptionsPage() {

    return (
        <ListRetailPrescriptions 
            routeType={routeTypes.admin}
        />
    )
}